import { LocaleCode, MarketCode } from '@tink/config/src/markets';

export type UserEntity = {
  created: number;
  endpoint: string | null;
  flags: (UserFlags | string)[];
  id: string;
  profile: {
    birth: string | null;
    currency: string;
    gender: string | null;
    locale: LocaleCode;
    market: MarketCode;
    periodAdjustedDay: number;
    periodMode: string;
    timeZone: string;
    fraudPersonNumber: string;
    name: string | null;
    cashbackEnabled: boolean;
    periodSettings: {
      mode: string;
      adjustedPeriodDay: number;
    };
    notificationSettings: {
      balance: boolean;
      budget: boolean;
      doubleCharge: boolean;
      income: boolean;
      largeExpense: boolean;
      summaryMonthly: boolean;
      summaryWeekly: boolean;
      transaction: boolean;
      unusualAccount: boolean;
      unusualCategory: boolean;
      einvoices: boolean;
      fraud: boolean;
      leftToSpend: boolean;
      loanUpdate: boolean;
    };
  };
  username: string | null;
  debugUntil: string | null;
  nationalId: string | null;
  label: string | null;
  externalUserId: string | null;
  appId: string | null;
};

export enum UserFlags {
  TEMPORARY = 'TEMPORARY',
}

export const User = {
  isTemporary: (user?: UserEntity) => {
    return user?.flags.includes(UserFlags.TEMPORARY);
  },
  isPermanent: (user?: UserEntity) => {
    return Boolean(user) && !user?.flags.includes(UserFlags.TEMPORARY);
  },
};
